<template>
  <CModal
      :show.sync="addSolutionModal"
      :centered="true"
      title="ثبت راه حل آزمون"
      size="md"
      class="text-right"
  >
    <CForm>
      <CTextarea v-model="form.solutionText" label="راه حل" class="text-sm"/>
      <div class="text-sm">افزودن عکس راه حل</div>
      <UploadFile
          v-if="addSolutionModal === true"
          v-model="form.solutionFileUrls"
          @upload-file="onUploadFile"
          cat="ES"
      />
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          color="primary"
          class="px-5"
          @click="addSolution"
      >
        ثبت
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadFile from "../../UploadFile/UploadFile.vue";

export default {
  components: {UploadFile},

  props: {
    value: {
      type: Boolean,
    },
    exam: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        solutionFileUrls: [],
      },
      loading: false,
    };
  },
  computed: {
    addSolutionModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    exam(newValue) {
      this.form = {
        solutionText: newValue.solutionText,
        solutionFileUrls: newValue.solutionFileUrls,
      };
    },
  },
  methods: {
    onUploadFile(file) {
      this.form.solutionFileUrls = file;
    },
    async addSolution() {
      try {
        this.loading = true;
        const payload = {
          solutionText: this.form.solutionText,
          solutionFileUrls: this.form.solutionFileUrls,
        };
        await axios
            .put(`/exam/${this.exam.id}/solution`, payload)
            .then((response) => {
              if (response.data.status) {
                this.form = {solutionFileUrls: []};
                this.addSolutionModal = false;
                this.$emit("get-exams");
              }
            });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>